export const commentTextCharactersLimit = 3000;
